import { Text } from "@mantine/core";
import { useParams } from "react-router-dom";
import { PageHeader } from "../../../components/PageHeader";
import { ObjectMetadataPanel } from "./ObjectMetadataPanel";

interface ObjectMetadataPageProps {
  objectType: string;
  paramName: string;
}

export const ObjectMetadataPage = ({
  objectType,
  paramName,
}: ObjectMetadataPageProps) => {
  const params = useParams();
  const objectId = params[paramName];

  if (!objectId) {
    return (
      <div className="wp-fade-in">
        <PageHeader title="Object Metadata" showBreadcrumbs={false} />
        <Text c="red">Missing route parameter: {paramName}</Text>
      </div>
    );
  }

  return (
    <div className="wp-fade-in">
      <PageHeader
        title="Object Metadata"
        subtitle="Manage metadata entries for this entity"
        showBreadcrumbs={false}
      />
      <ObjectMetadataPanel objectType={objectType} objectId={objectId} />
    </div>
  );
};
